import { useSelector } from 'react-redux';

export const usePublishInfo = (projectId, stateId = 'default') =>
  useSelector(
    (state) => state.firestore.data[`${projectId}.${stateId}.publishData`] || {}
  );
